import clsx from "clsx";
import { useAtom } from "jotai";
import { useId, useRef, useState } from "react";

import { queueAtom } from "~/atoms/queue";

import { MenuContext } from "./MenuContext";

export const Menu: React.FC<{
  children: React.ReactNode;
  placement?: "start" | "end";
}> = ({ children, placement = "end" }) => {
  const id = useId();
  const ref = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isTooltipHidden, setIsTooltipHidden] = useState(false);
  const [queue, setQueue] = useAtom(queueAtom);
  return (
    <div
      ref={ref}
      className={clsx(
        "dropdown dropdown-open",
        placement === "end" && "dropdown-end",
      )}
    >
      <MenuContext
        value={{
          parent: ref.current,
          isMenuOpen: isOpen,
          isLastOpened: queue[0] === id,
          toggleMenu: () => {
            setIsOpen((prev) => !prev);
            setQueue((prev) =>
              prev.includes(id)
                ? prev.filter((item) => item !== id)
                : [id, ...prev],
            );
          },
          closeMenu: () => {
            setIsOpen(false);
            setQueue((prev) => prev.filter((item) => item !== id));
          },
          isTooltipHidden,
          setIsTooltipHidden,
        }}
      >
        {children}
      </MenuContext>
    </div>
  );
};
